import { Injectable } from '@angular/core';

declare var window: any;

/**
 * This service serves as an adapter for working with the legacy javascript require method.
 * The require method does not work with a variable path (due to the nature of webpack, etc...),
 * all the paths must be hard-coded.
 */
@Injectable()
export class RequireAdapterService {
    constructor() { }

    loadBackboneView(): any {
        return require('common/views/BackboneView');
    }

    loadSysMessages(): any {
        return require('common/views/SystemMessages');
    }

    loadI18N(): any {
        return window.i18n;
    }

    loadCommonConstants(): any {
        return require('common/Const');
    }

    loadMediaPopup(): any {
        return require('common/mixins/mediaPopup');
    }

    loadNotificationListener(): any {
        return require('common/NotificationListener');
    }
}



// WEBPACK FOOTER //
// ./ts/app/shared/require-adapter.service.ts